import React from "react";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import QuantityButton from "../QuantitiyButton";
import {
  minusDestinationFloor,
  minusOriginFloor,
  plusDestinationFloor,
  plusOriginFloor,
  toggleElevatorDest,
  toggleElevatorOrigin,
} from "../../../actions/actionCreators";
import Switch from "@material-ui/core/Switch";
import { makeStyles } from "@material-ui/core/styles";
import i18n from "../../../i18nextInitiator";
import Divider from "../Divider";
import { connect } from "react-redux";
import Walking from "./Walking";

const t = i18n.getFixedT("fa", "general");

const useStyles = makeStyles((theme) => ({
  divider: {
    border: "solid .5px #d8d8d8",
    width: "100%",
    opacity: "0.5",
  },
  box: {
    margin: ".3rem 0",
  },
}));

const mapStateToProps = (state) => ({ ...state.order });

const SelectFloor = (props) => {
  const classes = useStyles();

  if (props.order.barbar_worker !== 0)
    return (
      <>
        <Divider />

        <Grid container className={classes.box}>
          <Grid container justifyContent={"space-between"}>
            <Grid item xs={"auto"} style={{ margin: "auto 0" }}>
              <Typography style={{ fontSize: 16 }}>
                {t("address.origin.floors")}
              </Typography>
            </Grid>
            <Grid item xs={"auto"}>
              <QuantityButton
                value={props.order.origin_floor}
                add={plusOriginFloor}
                remove={minusOriginFloor}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent={"space-between"}>
            <Grid item xs={"auto"} style={{ margin: "auto 0" }}>
              <Typography style={{ fontSize: 16 }}>{t("elevator")}</Typography>
            </Grid>
            <Grid item xs={"auto"}>
              <Typography component="div" onClick={toggleElevatorOrigin}>
                <Grid component="label" container alignItems="center">
                  <Grid item>{t("has-not")}</Grid>
                  <Grid item>
                    <Switch
                      classes={{ thumb: classes.thumb }}
                      color="primary"
                      checked={props.order.asansor_origin}
                    />
                  </Grid>
                  <Grid item>{t("has")}</Grid>
                </Grid>
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Divider />

        <Grid container className={classes.box}>
          <Grid container justifyContent={"space-between"}>
            <Grid item xs={"auto"} style={{ margin: "auto 0" }}>
              <Typography style={{ fontSize: 16 }}>
                {t("address.destination.floors")}
              </Typography>
            </Grid>
            <Grid item xs={"auto"}>
              <QuantityButton
                value={props.order.destination_floor}
                add={plusDestinationFloor}
                remove={minusDestinationFloor}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent={"space-between"}>
            <Grid item xs={"auto"} style={{ margin: "auto 0" }}>
              <Typography style={{ fontSize: 16 }}>{t("elevator")}</Typography>
            </Grid>
            <Grid item xs={"auto"}>
              <Typography component="div" onClick={toggleElevatorDest}>
                <Grid component="label" container alignItems="center">
                  <Grid item>{t("has-not")}</Grid>
                  <Grid item>
                    <Switch
                      classes={{ thumb: classes.thumb }}
                      color="primary"
                      checked={props.order.asansor_dest}
                    />
                  </Grid>
                  <Grid item>{t("has")}</Grid>
                </Grid>
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Walking />
      </>
    );
  return null;
};

export default connect(mapStateToProps)(SelectFloor);
